<template>
<!-- 入职三个月回顾 -->
  <div class="detail">
    <ax-panel> 
      <section>
        <div class="sub-title">工作目标及职责:</div>
        <p class="con" v-html="qh_comments_001"></p>
      </section>
      <section class="top-item">
        <div class="sub-title">三个月工作业绩回顾:</div>
        <p class="con" v-html="qh_comments_002"></p>
      </section>
      <section class="top-item">
        <div class="sub-title">公司的意见和建议:</div>
        <p class="con" v-html="qh_comments_003"></p>
      </section>
    </ax-panel>
    
    <ax-panel title="申请人信息">
      <van-cell title="姓名" :value="data.header.emplid_description"></van-cell>
      <!-- <van-cell title="邮箱">
        <a class="mail_a" :href="'mailto:'+data.header.email_addr">{{data.header.email_addr}}</a>
      </van-cell> -->
      <van-cell title="电话">
        <a class="link_a" :href="'tel:'+data.header.emplid_phone">{{data.header.emplid_phone}}</a>
      </van-cell>
      <van-cell title="部门" :value="data.header.deptid_description"></van-cell>
    </ax-panel>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data(){
    return {
      qh_comments_001: '',
      qh_comments_002: '',
      qh_comments_003: '',
    }
  },
  watch: {
    data(){
      this.getData();
    }
  },
  mounted(){
    this.getData();
  },  
  methods:{
    getData(){
      if(this.data){
        this.qh_comments_001 = this.data.header.qh_comments_001 ? this.data.header.qh_comments_001.replace(/</g, '＜').replace(/>/g, '＞').replace(/\r\n|\n|↵|\r/g, '<br/>') : '';
        this.qh_comments_002 = this.data.header.qh_comments_002 ? this.data.header.qh_comments_002.replace(/</g, '＜').replace(/>/g, '＞').replace(/\r\n|\n|↵|\r/g, '<br/>') : '';
        this.qh_comments_003 = this.data.header.qh_comments_003 ? this.data.header.qh_comments_003.replace(/</g, '＜').replace(/>/g, '＞').replace(/\r\n|\n|↵|\r/g, '<br/>'): '';
      }
    }
  }
}
</script>
<style lang="scss" scoped>
section{
  padding: 0 10px;
}
.top-item .sub-title{
  padding-top: 10px;
}
.sub-title{
  color:#222;
  font-size: 0.36rem;
}
.con{
  padding: 0.24rem ;
  line-height: 1.4;
  color: #666;
}
</style>